// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1570) return "static/chunks/29107295-791f0e613da91548.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"268":"b84700df670085e5","6044":"629b361f7f9658ef"}[chunkId] + ".js";
};